var map = {
	"./android.svg": "d310",
	"./chrome.svg": "8609",
	"./chrome_os.svg": "e6ed",
	"./debian.svg": "15c0",
	"./edge.svg": "1670",
	"./firefox.svg": "678a",
	"./freebsd.svg": "1b00",
	"./ie.svg": "f64b",
	"./ios.svg": "6f5c",
	"./linux.svg": "129b",
	"./netscape.svg": "57c2",
	"./opera.svg": "5e4d",
	"./safari.svg": "af31",
	"./ubuntu.svg": "c450",
	"./unknown.svg": "0b17",
	"./windows10.svg": "f44b",
	"./windows_xp.svg": "98fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f88a";